import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext } from 'react';
import { Modal } from '..';
import { AppContext } from '../../../state/app.state';
import { isMobile } from '../../../utils/app.helper';

type IframeModalProps={

};

const IframeModal: React.FC<IframeModalProps> = (): ReactElement => {
    const { state, presentationState } = useContext(AppContext);

    return useObserver (() => (
        <Modal
            showModal={!!presentationState?.currentIframe}
            onBackdropClick={(): void => presentationState?.setCurrentIframe(undefined)}
            modalPaperStyle={{
                maxWidth: isMobile() ? 'calc(100% - 2rem)' : '90%',
                height:'calc(100% - 2rem)',
                width:`calc(${document.getElementsByClassName('bv-aspect-outer')[0]?.clientWidth}px - 2rem)`,
                borderRadius: '2rem',
                overflow:'hidden',
                margin: isMobile() ? 'unset' : '32px' }}>
            <iframe allowFullScreen className='bv-app-iframe' style={{ border: 'none', width: '100%', height: '100%' }} src={state?.project?.tours?.find(t => t.id === presentationState?.currentIframe?.id)?.url || ''} title='Rundvandring'/>
        </Modal>
    ));
};


export default IframeModal;